// local storage key
const LATEST_ADMIN_LOGIN_KEY = 'lal';
function isLatestAdminLogin() {
    return !!window.localStorage.getItem(LATEST_ADMIN_LOGIN_KEY);
}
function setLatestAdminLogin() {
    const timeStamp = ((new Date()).getTime()).toString();
    window.localStorage.setItem(LATEST_ADMIN_LOGIN_KEY, timeStamp);
}
function removeLatestAdminLogin() {
    window.localStorage.removeItem(LATEST_ADMIN_LOGIN_KEY);
}
export { isLatestAdminLogin, setLatestAdminLogin, removeLatestAdminLogin };
//# sourceMappingURL=localStorage.js.map